import { render } from "./RecipientsStatusPopUp.vue?vue&type=template&id=9a225c88"
import script from "./RecipientsStatusPopUp.vue?vue&type=script&lang=js"
export * from "./RecipientsStatusPopUp.vue?vue&type=script&lang=js"
script.render = render

export default script